/**
 * PAYLOAD ATTRIBUTES
 *  - checkinId
 *  - customerType
 *  - deliveryAddress
 *  - items: alias to orders
 *  - orderInstruction
 *  - orderType
 *  - orderUnderName
 *  - phoneNumber
 *  - restauId
 *  - scheduledDate
 *  - scheduledOrder: computed
 *  - scheduledTime
 *  - tableId
 *  - tip
 */

import { getTip } from '../Order.utils';
import encrypt from '../../Utils/encrypt';

const getPayload = (
    {
        checkinId,
        customerType,
        deliveryAddress,
        deliveryFees,
        isOrderAheadEnabled,
        orderInstruction,
        orders: items,
        orderType,
        orderUnderName,
        phoneNumber,
        restauId,
        scheduledDate,
        scheduledForLater,
        scheduledTime,
        tableId,
        tipPercent,
        getOrderSubtotal,
        cardNumber,
        expiry,
        cvc,
        zip,
        payAtStore,
        payNow,
        deliveryAPT,
        deliveryScheduledForLater,
        deliveryScheduledDate,
        deliveryScheduledTime,
    },
    cateringMode,
    inquiryId,
    eventId
) => {
    //debugger;
    const subtotal = getOrderSubtotal();
    const tip = getTip(subtotal, tipPercent);
    let paymentInfo = null;
    if (cardNumber && expiry && cvc) {
        paymentInfo = {
            cardNumber: cardNumber,
            expiry: expiry,
            cvc: cvc,
            zip: zip,
        };
        paymentInfo = encrypt(JSON.stringify(paymentInfo));
    }
    let scheduledOrder =
        isOrderAheadEnabled && scheduledForLater ? true : false;
    if (orderType === 'Delivery') {
        scheduledOrder = false;
        scheduledDate = null;
        scheduledTime = null;
    }
    const tempPayload = {
        checkinId,
        customerType,
        items,
        orderInstruction,
        orderType,
        orderUnderName,
        phoneNumber,
        restauId,
        scheduledDate,
        scheduledOrder: scheduledOrder,
        scheduledTime,
        tip,
        payAtStore,
        payNow,
        deliveryScheduledForLater,
        deliveryScheduledDate,
        deliveryScheduledTime,
    };
    if (tableId) {
        tempPayload.tableId = tableId;
    }
    if (deliveryAPT && deliveryAddress) {
        let dparts = deliveryAddress.split(',');
        if (dparts.length >= 3) {
            // dparts = [ '1060 Market Drive', ' Vernal', ' UT', ' USA' ]
            // ' Suite/Apt: #623'
            dparts.splice(dparts.length - 3, 0, ' Suite/Apt: #' + deliveryAPT);
            tempPayload.deliveryAddress = dparts.join(',');
        } else {
            tempPayload.deliveryAddress =
                'Suite/Apt: #' + deliveryAPT + ', ' + deliveryAddress;
        }
    } else if (deliveryAddress) {
        tempPayload.deliveryAddress = deliveryAddress;
    }
    if (deliveryFees) {
        tempPayload.deliveryFees = deliveryFees;
    }
    if (paymentInfo) {
        tempPayload.paymentInfo = paymentInfo;
    }
    if (
        window.location.hostname == 'strideq.com' ||
        window.location.hostname == 'www.strideq.com' ||
        window.location.hostname == 'localhost'
    ) {
        tempPayload.legacyDomain = true;
    }
    if (cateringMode) {
        // let original_subtotal = 0;
        // let subtotal = 0;
        // let salestax_percent = orderToUpdate
        //     ? orderToUpdate.payment_salestax_percent
        //     : defaultTax;
        // for (let key in items) {
        //     let item = items[key];
        //     original_subtotal += item.quantity * item.original_price;
        //     subtotal += item.quantity * item.price;
        // }
        // let discount_amount = orderToUpdate.discount.amount;
        // if (orderToUpdate.discount.discount_type === 'Percent') {
        //     discount_amount = Math.round(
        //         (subtotal * orderToUpdate.discount.percent_off) / 100
        //     );
        // }
        //debugger;
        return {
            restauId,
            inquiryId: inquiryId,
            eventId: eventId,
            paymentType: undefined,
            cateringOrderFromTakeout: true,
            eventData: {
                customerName: orderUnderName,
                Company: '',
                email: '',
                phone: phoneNumber,
                numOfGuests: '',
                specialIns: '',
                eventStatus: 'New Event',
                OtherStatusReasons: '',
                eventStatusReason: '',
                followupDueDate: '',
                internalNotes: '',
                inquiryId: inquiryId,
                restauId: restauId,
                eventId: eventId,
                canEdit: true,
                submissionTimestamp: Date.now(),
                eventDate: scheduledDate,
                startTime: scheduledTime,
                orders: {
                    items: items,
                    discount: {},
                    gratuity: {
                        gratuity_type: 'Percent',
                        amount: tip,
                        percent: tipPercent,
                    },
                    payment_subtotal_original: 0,
                    payment_subtotal_before_discount: 0,
                    payment_subtotal: null,
                    payment_salestax: null,
                    payment_salestax_percent: 0,
                    payment_total: null,
                    tip: tip,
                    orderInstruction: orderInstruction,
                    orderInstructionInternal: '',
                    deposit_payment: false,
                    deposit_amount_paid: 0,
                    deposit_amount: 0,
                    deposit_payment_success: false,
                    deposit_payment_method: '',
                    deposit_payment_success_timestamp: '',
                    deposit_payment_collected_by: '',
                    deposit_paid_via_stripe: false,
                    invoice_payment: false,
                    invoice_amount_paid: 0,
                    invoice_payment_success: false,
                    invoice_payment_method: '',
                    invoice_payment_success_timestamp: '',
                    invoice_payment_collected_by: '',
                    invoice_paid_via_stripe: false,
                    orderType: 'catering',
                },
            },
        };
    } else {
        return tempPayload;
    }
};

export default getPayload;
